// All polling intervals are in milliseconds
export const DASHBOARD_POLLING_INTERVAL = 10000 // 10s
export const DETAILS_POLLING_INTERVAL = 5000 // 5s
export const NOTIFICATIONS_POLLING_INTERVAL = 10000 // 10s
export const DASHBOARD_KPI_INTERVAL = 60000 // 60s
export const DASHBOARD_ASSET_MONITORING_INTERVAL = 10000 // 10s
export const DASHBOARD_BEHAVIOR_INTERVAL = 10000 // 10s



// WEBPACK FOOTER //
// ./src/constants/polling-interval.constants.js